module.exports = __webpack_public_path__ + "static/img/drcktioong.a4cff94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/drcktioong.png
// module id = Wimk
// module chunks = 44